(function(){
  var SECS='mt-cart-drawer,cart-icon-bubble';
  var cd=document.getElementById('mt-cd');
  var onPage=function(){return !!document.querySelector('[data-mt-cart-page]');};
  function open(){ if(!cd||onPage())return; cd.classList.add('is-open'); cd.setAttribute('aria-hidden','false'); document.documentElement.classList.add('mt-cd-lock'); }
  function close(){ if(!cd)return; cd.classList.remove('is-open'); cd.setAttribute('aria-hidden','true'); document.documentElement.classList.remove('mt-cd-lock'); }
  function html(s){ var d=document.createElement('div'); d.innerHTML=s; return d; }
  function render(sections){
    if(!sections)return;
    if(sections['mt-cart-drawer']){
      var nb=html(sections['mt-cart-drawer']).querySelector('[data-mt-cb]');
      if(nb) document.querySelectorAll('[data-mt-cb]').forEach(function(el){ el.replaceWith(nb.cloneNode(true)); });
    }
    var bub=document.getElementById('cart-icon-bubble');
    if(bub && sections['cart-icon-bubble']){
      var s=html(sections['cart-icon-bubble']).querySelector('.shopify-section');
      if(s) bub.innerHTML=s.innerHTML;
    }
  }
  function busy(on){ document.querySelectorAll('[data-mt-cb]').forEach(function(el){ el.classList.toggle('is-busy',on); }); }
  function post(url,body){
    return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
      .then(function(r){ if(!r.ok) throw r; return r.json(); });
  }
  function change(line,qty){ return post('/cart/change.js',{line:line,quantity:qty,sections:SECS,sections_url:location.pathname}); }

  // Agregar al carrito sin salir de la página
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(!f.action || f.action.indexOf('/cart/add')===-1) return;
    e.preventDefault();
    var btn=f.querySelector('[type=submit]'); if(btn){btn.disabled=true;btn.classList.add('is-loading');btn.dataset.txt=btn.innerHTML;btn.innerHTML='Yendo al pago seguro…';}
    var fd=new FormData(f); fd.append('sections',SECS); fd.append('sections_url',location.pathname);
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:fd})
      .then(function(r){ if(!r.ok) throw r; return r.json(); })
      .then(function(){ window.location.href='/checkout'; })
      .catch(function(){ f.submit(); })
      .catch(function(){ if(btn){btn.disabled=false;btn.classList.remove('is-loading');btn.innerHTML=btn.dataset.txt;} });
  },true);

  document.addEventListener('click',function(e){
    var t=e.target;
    var bub=t.closest && t.closest('#cart-icon-bubble');
    if(bub && cd && !onPage()){ e.preventDefault(); open(); return; }
    if(t.closest('[data-mt-cart-close]')){
      if(t.closest('a[href]') && onPage()) return;
      if(t.closest('a[href]') && location.pathname!=='/' ){ return; }
      e.preventDefault(); close(); return;
    }
    var q=t.closest('[data-mt-qty]');
    if(q){
      var line=+q.closest('[data-line]').getAttribute('data-line');
      busy(true);
      change(line,+q.getAttribute('data-mt-qty')).then(function(d){render(d.sections);}).catch(function(){location.reload();}).finally(function(){busy(false);});
      return;
    }
    var u=t.closest('[data-mt-upgrade]');
    if(u){
      busy(true);
      var id=+u.getAttribute('data-mt-upgrade'), ln=+u.getAttribute('data-mt-upline');
      change(ln,0).then(function(){ return post('/cart/add.js',{items:[{id:id,quantity:1}],sections:SECS,sections_url:location.pathname}); })
        .then(function(d){render(d.sections);}).catch(function(){location.reload();}).finally(function(){busy(false);});
    }
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
})();
